import { render, staticRenderFns } from "./UpdateAvailable.vue?vue&type=template&id=8719ce72&scoped=true"
import script from "./UpdateAvailable.vue?vue&type=script&lang=js"
export * from "./UpdateAvailable.vue?vue&type=script&lang=js"
import style0 from "./UpdateAvailable.vue?vue&type=style&index=0&id=8719ce72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8719ce72",
  null
  
)

export default component.exports